export const URL_ARRIVEL = 'https://eurotrans.by/local/components/travelsoft/eurotrans.search_form/ajax/arrivalpoints.php';
export const URL_DATES = 'https://eurotrans.by/local/components/travelsoft/eurotrans.search_form/ajax/dates.php';
export const root_elem = document.querySelector('#root');